import React from "react";
import {moduleService} from "../jwt/_services";

export const moduleProvider = {
    getOptions,
    getItem,
};

async function getOptions(){
    try {
        const listItems = await moduleService.search(0, 100, null);

        return listItems.data.map((itemData) => {
            const { id, name, code } = itemData
            return (
                {
                    id: id,
                    value: code + ' - ' + name,
                    label: <div><label>{ code + ' - ' + name }</label></div>}
            )
        });
    } catch (error) {
       console.log(error.message)
    }
}

async function getItem(id){
    try {
        const item = await moduleService.getItem(id);

        return (
            {
                id: item.id,
                value: item.code + ' - ' + item.name,
                label: <div><label>{item.code + ' - ' + item.name}</label></div>}
        );
    } catch (error) {
        console.log(error.message)
    }
}